import { IChartSeries } from '@mais-retorno-front/models/chart-serie';
import {  IAssetQuotes } from '../interfaces';

export const createSheetFundsQuotaHoldersSerieChart = (
  fundQuotes: IAssetQuotes,
  netWorthColor = '#0F132A'
): IChartSeries[] => {
  if (!fundQuotes) return;

  const data = fundQuotes.quotes.map(({ d, p, q }) => ({
    date: d,
    quotaHolder: q,
    netWorth: p,
  }));

  let quotaHolderChartData = [];

  const quotaHolderData = {
    type: 'line',
    data: new Array(data.length),
    name: 'Cotistas',
    color: fundQuotes.color,
  };

  const midPatrimonyData = {
    type: 'line',
    data: new Array(data.length),
    name: 'Patrimônio médio por cotista',
    yAxis: 1,
    color: netWorthColor,
  };

  for (let i = 0; i < data.length; i++) {
    const period = data[i].date;

    quotaHolderData.data[i] = [period, data[i].quotaHolder || 0];

    if (data[i].quotaHolder) {
      midPatrimonyData.data[i] = [
        period,
        data[i].netWorth / data[i].quotaHolder,
      ];
    } else {
      midPatrimonyData.data[i] = [period, 0.0];
    }
  }

  quotaHolderChartData = [quotaHolderData, midPatrimonyData];

  return quotaHolderChartData;
};
